import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TenantOption} from "../model/Theme";

@Injectable({
    providedIn: 'root'
})
export class TenantService {
    private baseUrl = `${environment.apiBaseUrl}/tenant`;

    constructor(private http: HttpClient) {
    }

    getTenantList(): Observable<TenantOption[]> {
        return this.http.get<TenantOption[]>(`${this.baseUrl}/all`);
    }


}
